/**
 * Enum do Estado Macro de um ativo no Painel de Status de Comunicação.
 *
 * A regra de consolidação está descrita em
 * docs/adr/0008-estado-macro-em-tres-niveis.md
 */
export const assetStates = {
  ATTENTION: 'attention',
  NORMAL: 'normal',
  OUT_OF_SERVICE: 'out-of-service',
};

/**
 * Estados ordenados do mais grave para o menos grave.
 *
 * Usado tanto para consolidar sensores em um ativo quanto ativos
 * em uma instalação: em ambos os casos vence o pior.
 */
export const assetStatesBySeverity = [
  assetStates.ATTENTION,
  assetStates.NORMAL,
  assetStates.OUT_OF_SERVICE,
];

export default assetStates;
